import { Target, Layers, RefreshCw, FileCode, Bug, Shield } from "lucide-react";

export const PromptEngTechniques = () => {
  const techniques = [
    {
      icon: Target,
      title: "Be Specific About Context",
      description: "Always include: language/framework, project type, constraints, and your current setup.",
      example: "I'm building a React app with TypeScript, using Tailwind CSS and shadcn/ui. I need a...",
      color: "text-primary",
      bgColor: "bg-primary/10",
    },
    {
      icon: Layers,
      title: "Use Role Prompting",
      description: "Tell the AI to act as a specific expert for better, more focused responses.",
      example: "Act as a senior React developer who specializes in performance optimization...",
      color: "text-chart-2",
      bgColor: "bg-chart-2/10",
    },
    {
      icon: RefreshCw,
      title: "Iterate Incrementally",
      description: "Build complex features step by step. Don't try to generate everything at once.",
      example: "First, create the basic component structure. Then we'll add state management...",
      color: "text-chart-4",
      bgColor: "bg-chart-4/10",
    },
    {
      icon: FileCode,
      title: "Provide Examples",
      description: "Show the AI what you want with examples of similar code or patterns.",
      example: "Here's an example of how I structure my other components: [code]. Follow this pattern for...",
      color: "text-chart-1",
      bgColor: "bg-chart-1/10",
    },
    {
      icon: Bug,
      title: "Include Error Messages",
      description: "When debugging, paste the full error message and stack trace for better diagnosis.",
      example: "I'm getting this error: [full error]. It happens when [action]. Expected behavior is [...]",
      color: "text-destructive",
      bgColor: "bg-destructive/10",
    },
    {
      icon: Shield,
      title: "Ask for Explanations",
      description: "Request explanations with the code to learn and catch issues early.",
      example: "...and explain each section so I understand the approach and can modify it later.",
      color: "text-chart-3",
      bgColor: "bg-chart-3/10",
    },
  ];

  return (
    <section className="py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">
        Essential Prompting Techniques
      </h2>
      <p className="text-muted-foreground mb-8 max-w-3xl">
        These techniques will dramatically improve the quality of AI-generated code.
      </p>

      <div className="grid md:grid-cols-2 gap-6">
        {techniques.map((technique, index) => (
          <div
            key={index}
            className="bg-card rounded-xl border border-border p-6 hover:border-primary/30 transition-colors"
          >
            <div className="flex items-start gap-4">
              <div className={`w-12 h-12 rounded-xl ${technique.bgColor} flex items-center justify-center shrink-0`}>
                <technique.icon className={`w-6 h-6 ${technique.color}`} />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-foreground mb-2">{technique.title}</h3>
                <p className="text-sm text-muted-foreground mb-3">{technique.description}</p>
                <code className="text-xs text-primary bg-primary/5 p-2 rounded block">
                  {technique.example}
                </code>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
